const emailDesigner = {
  searchTemplates: "Поиск шаблонов...",
  allCategories: "Все категории",
  newTemplate: "Новый шаблон",
  templates: "Шаблоны",
  noTemplates: "Нет шаблонов",
  selectOrCreate: "Выберите шаблон или создайте новый",
  untitledTemplate: "Без названия",
  defaultSubject: "Тема письма",
  copy: "Копия",
  duplicate: "Дублировать",
  delete: "Удалить",
  subject: "Тема",
  subjectPlaceholder: "Введите тему письма...",
  insertVariable: "Вставить переменную",
  mergeVariables: "Переменные слияния",
  variables: "Переменные",
  edit: "Редактирование",
  preview: "Предпросмотр",
  previewMode: "Режим предпросмотра",
  previewHint: "Переменные показаны с примерами",
  catSystem: "Системный",
  catTransactional: "Транзакционный",
  catMarketing: "Маркетинг",
} as const;
export default emailDesigner;
